import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getUserQuests } from 'services/questsService'
//types
import { UserQuestsResponse } from 'types'
//utils
import { handleError } from 'utils/utils'

const useQueryGetAllUserQuests = () => {
  const { data, isLoading } = useQuery<AxiosResponse<UserQuestsResponse, Error>>(
    QueryKeys.USER_QUESTS,
    () => getUserQuests(),
    { onError: handleError }
  )

  return { userQuests: data?.data, isLoadingQuests: isLoading }
}

export default useQueryGetAllUserQuests
